import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Button from '@mui/material/Button';
import { SpinnerCircular } from 'spinners-react';

import TextField from "@mui/material/TextField";

import useHttp from "../../../hooks/useHttp";
import "../../../assets/css/utility/input-field.css";
import "../../../assets/css/user_auth_pages.css";
import SuccessMessage from "../../../components/SuccessMessage";
import { FORGET_PASSWORD_URL } from "../../../utils/api-ends";

const ForgetPassword = () => {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState([]);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState([]);

  const [resetMedia, setResetMedia] = useState("email");
  const [errorMessages, setErrorMessages] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");

  const { error, isLoading, sendRequests } = useHttp();
  const navigate = useNavigate();

  const onEmailChange = (e) => setEmail(e.target.value);
  const onPhoneNumberChange = (e) => setPhoneNumber(e.target.value);

  const handleResetMedia = () => {
    if (resetMedia === "email") {
      setResetMedia("phone_number");
    } else {
      setResetMedia("email");
    }
  };

  const onSubmit = () => {
    if(isLoading) return false;
    // Clear messages before submitting form data
    setErrorMessages([]);
    setEmailError([]);
    setPhoneNumberError([]);
    setSuccessMessage("");

    if (resetMedia === "email" && email?.trim()?.length === 0) {
      setEmailError(["Email is required"]);
      return;
    } else if (
      resetMedia === "phone_number" &&
      phoneNumber?.trim()?.length === 0
    ) {
      setPhoneNumberError(["Phone number is required"]);
      return;
    }

    const response = (data) => {
      setSuccessMessage(data.message);

      setTimeout(() => {
        navigate("/auth/reset-password");
      }, 500);
    };

    let data = {};
    if (resetMedia === "email") {
      data["email"] = email;
    } else if (resetMedia === "phone_number") {
      data["phone_number"] = phoneNumber;
    }

    sendRequests(
      {
        url: FORGET_PASSWORD_URL,
        method: "POST",
        data: data,
      },
      response
    );
  };

  useEffect(() => {
    if (error) {
      setErrorMessages([error.message]);
    }
    if (error?.general) {
      setErrorMessages([error.general]);
    }
  }, [error]);

  return (
    <>
      <p className="auth-instruction"></p>

      <div className="user-input-field">
        {errorMessages?.map((error, index) => (
          <p className="auth-error" key={index}>
            {error}
          </p>
        ))}

        {successMessage?.length > 0 && (
          <SuccessMessage message={successMessage} />
        )}

        {resetMedia === "email" && (
          <div className="input-box-area">
            {emailError?.map((error, index) => (
              <p className="auth-error" key={index}>
                {error}
              </p>
            ))}

            <TextField
              fullWidth
              autoFocus
              className="the-mui-input-field"
              onChange={onEmailChange}
              label="Email Address"
              variant="outlined"
              value={email}
            />
          </div>
        )}

        {resetMedia === "phone_number" && (
          <div className="input-box-area">
            {phoneNumberError?.map((error, index) => (
              <p className="auth-error" key={index}>
                {error}
              </p>
            ))}

            <TextField
              fullWidth
              className="the-mui-input-field"
              onChange={onPhoneNumberChange}
              label="Phone Number"
              variant="outlined"
              value={phoneNumber}
            />
          </div>
        )}

        <Button className="theme-btn submit-btn" onClick={onSubmit}>
          Submit
          {
            isLoading &&
            <SpinnerCircular 
              size={22} 
              thickness={180} 
              speed={130} 
              color="#fff" 
              className="btn-loader"
              secondaryColor="rgba(57, 172, 127, 0.44)" 
            />
          }
        </Button>
      </div>

      <a href="#" className="auth-usefull-links" onClick={handleResetMedia}>
        Want to reset by
        {resetMedia === "email" ? " phone number" : " email address"} ?
      </a>

      <Link to="/auth/sign-in" className="auth-usefull-links">
        Sign In
      </Link>

      <Link to="/auth/sign-up" className="auth-usefull-links">
        Create an Account
      </Link>
    </>
  );
};

export default ForgetPassword;
